import Listbox from '@oncolens/oncolens-ui/lib/components/FormControls/Listbox';
import TextInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextInput';
import { useConfigs } from '@oncolens/oncolens-ui/lib/hooks/common/useConfig';
import React from 'react';
import RequestFormField from './RequestFormField';
import RequestSection from './RequestSection';

function PatientSection() {
  const formKey = 'patient';
  const configs = useConfigs(['sex', 'race', 'ethnicities']);

  return (
    <RequestSection title="2. Provide the basic patient demographics">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-5">
        <RequestFormField name={`${formKey}.age`}>
          {({ value, onChange, errorMessage }) => (
            <TextInput
              id="age"
              label="Age"
              htmlName="age"
              placeholder="Please enter the patient's age"
              type="number"
              required={true}
              error={errorMessage}
              value={value}
              onChange={onChange}
            />
          )}
        </RequestFormField>

        <RequestFormField name={`${formKey}.sexId`}>
          {({ value, onChange, errorMessage }) => (
            <Listbox
              label="Sex"
              required={true}
              data={configs?.sex || []}
              error={errorMessage}
              selected={value}
              setSelected={onChange}
            />
          )}
        </RequestFormField>

        <RequestFormField name={`${formKey}.raceId`}>
          {({ value, onChange, errorMessage }) => (
            <Listbox
              label="Race"
              data={configs?.race || []}
              error={errorMessage}
              selected={value}
              setSelected={onChange}
            />
          )}
        </RequestFormField>

        <RequestFormField name={`${formKey}.ethnicityId`}>
          {({ value, onChange, errorMessage }) => (
            <Listbox
              label="Ethnicity"
              data={configs?.ethnicities || []}
              error={errorMessage}
              selected={value}
              setSelected={onChange}
            />
          )}
        </RequestFormField>

        <RequestFormField name={`${formKey}.zip`}>
          {({ value, onChange, errorMessage }) => (
            <TextInput
              id="zip"
              label="Zip"
              htmlName="zip"
              placeholder="Patient Zip"
              type="text"
              error={errorMessage}
              value={value}
              onChange={onChange}
            />
          )}
        </RequestFormField>
      </div>
    </RequestSection>
  );
}

export default PatientSection;
